import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-unity-viewer',
  templateUrl: './unity-viewer.component.html',
  styleUrls: ['./unity-viewer.component.scss'],
})
export class UnityViewerComponent implements OnInit {
  unityViewerUrl: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    const url = 'assets/measurements/index.html';
    this.unityViewerUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
